import React from 'react';

import s from './style.module.css';

type Heading1Props = {
    title: string;
};

export const Heading1 = (props: Heading1Props) => {
    return <h1 className={s.heading}>{props.title}</h1>;
};

export default Heading1;
